import * as React from 'react';
import * as showdown from 'showdown';
import '../styles/entry.css';

const showdownConverter = new showdown.Converter({
  simplifiedAutoLink: true,
  emoji: true,
});

export interface Entry {
  short: string;
  content: string;
}

export interface EntryProps {
  entry: Entry;
}

export const ReadableEntry: React.SFC<EntryProps> = (props) => {
  return (
    <div className="entry" dangerouslySetInnerHTML={{__html: showdownConverter.makeHtml(props.entry.content)}} />
  );
};

export interface EditableEntryProps {
  onChange: (value: string) => void;
  isDirty: boolean;
}

export const EditableEntry: React.SFC<EntryProps & EditableEntryProps> = (props) => {
  const changeHandler = (e: React.FormEvent<HTMLTextAreaElement>) => {
    props.onChange(e.currentTarget.value);
  };

  const className: string = 'editable-entry' + (props.isDirty ? ' unsaved' : '');

  return (
    <textarea
      className={className}
      onChange={changeHandler}
      value={props.entry.content}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/entry.tsx